@if (profileField$ | async; as profileField) {
    <dt [id]="profileField.FieldDefinition.DottedKey" class="sh-description-list__term" style="{{ nestedPadding$ | async }}">
        <sh-field-label [label]="profileField.DisplayLabel" [labelIcons]="$labelIcons()"></sh-field-label>
    </dt>
    @if (value$ | async; as value) {
        <dd class="sh-link sh-description-list__details">
            <a [title]="value" [href]="value" class="sh-link" target="_blank" rel="noopener noreferrer">{{ value }}</a>
        </dd>
    } @else {
        <dd class="sh-description-list__details">-</dd>
    }
}
